module.exports = __webpack_public_path__ + "a1bdc17fe1fb385db4a279108af015e0.svg";